import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import AllLifeTimeEmails from './lifeTimeEmails';

class LifeTimeEmail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            breadcrumbItems : [
                { title : "Minimis", link : "/" },
                { title : "Android Beta Emails", link : "#" },
            ],
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>

                    <Breadcrumbs title="" breadcrumbItems={this.state.breadcrumbItems} />
                        <Row>
                               <AllLifeTimeEmails/>
                        </Row>

                    </Container> 
                </div>
            </React.Fragment>
        );
    }
}

export default LifeTimeEmail;
